module.exports = __webpack_public_path__ + "static/media/award2.4a59b65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/award2.png
// module id = 1181
// module chunks = 0